import NewNorthBuildingSection from './newNorthBuildingSection';

export default NewNorthBuildingSection;
